var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CurrentStockAdjustTemp',{attrs:{"goods-option":"S0102","goods-type":"반제품"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }